module.exports = __webpack_public_path__ + "../resources/img/ic_plus_dark.92142165.svg";